import React from "react";
import { Row, Col } from "react-bootstrap";
import usePoolToken from "../../../hooks/usePoolToken";
import { formatPercentage } from "../../../utils/format";
import useGenericCall from "../../../hooks/useGenericCall";
import { useOffchainBorrowable } from "../../../hooks/useOffchain";
import { PoolTokenType } from "impermax-sdk";


export default function FarmingAPR({ amount }: { amount: number }) {
  const poolTokenType = usePoolToken();
  if (poolTokenType == PoolTokenType.Collateral) return null;

  const farmingAPR = useGenericCall(
    useOffchainBorrowable(), 
    offchainBorrowable => offchainBorrowable.getNextFarmingAPR(amount),
    [amount]
  );

  if (farmingAPR == 0) return (null);

  return (
    <Row>
      <Col xs={6}>Farming APR:</Col>
      <Col xs={6} className="text-right">{formatPercentage(farmingAPR)}</Col>
    </Row>
  );
}